import { inject, provide } from 'vue'

import KeyValue from '@/features/ui/components/keyValue/KeyValue.vue'

export function useBlockFormPresenterValues({ personId, fieldsDisabled, mode }) {
  return {
    mode,
    entityId: personId,
    fieldValueRendererTemplate: KeyValue,
    fieldRendererTemplate: KeyValue,
    fieldsDisabled,
  }
}

const key = Symbol('_blockFormPresenterValues_')

export function provideBlockFormPresenterValues(vals) {
  provide(key, useBlockFormPresenterValues(vals))
}

export function injectBlockFormPresenterValues() {
  return inject(key)
}
